import { SendIcon } from "components/ui/icons/button/SendIcon"
import { ButtonPrimary } from "../ButtonPrimary/ButtonPrimary"
import style from "./ButtonSend.module.scss"

const { buttonSend } = style

type Props = {
	submittable?: boolean
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const ButtonSend = ({ submittable = true, onClick }: Props) => {
	return (
		<ButtonPrimary className={buttonSend} submittable={submittable} onClick={onClick}>
			<SendIcon submittable={submittable} />
		</ButtonPrimary>
	)
}
